import { string, date, object } from "yup";
import { matchIsValidTel } from "mui-tel-input";
import { isDate } from "date-fns";
import dayjs from "dayjs";
import * as Yup from "yup";

const parseDateString = (originalValue) => {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : new Date(dayjs(originalValue));
  return parsedDate;
};

export const validationAddActorSchema = object().shape({
  profileImage: Yup.mixed()
    .nullable()
    .test("Compare", "Profile Pic is required", (value) => value),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  mobileNo: string()
    .trim()
    .test("myphone", "Invalid mobile no", (value) => matchIsValidTel(value))
    .required("Mobile no is required"),
  email: string()
    .trim()
    .email("Invalid email id")
    .required("Email is required"),
  profileCategoryId: Yup.string().required("Profile category is required"),
  location: Yup.string().required("Location is required"),
  bio: string().trim(),
  gender: string().required("Gender is required"),
  contactVisibility: string().required("Contact privacy is required"),
  businessEmail: string()
    .trim()
    .email("Invalid email id")
    .required("Business email is required"),
  businessMobileNo: string()
    .trim()
    .notRequired()
    .test("myphone", "Invalid mobile no", (value) => matchIsValidTel(value))
    .required("Business mobile is required"),
  dob: date()
    .typeError("Invalid Date of Birth")
    .transform(parseDateString)
    .required("Invalid Date of Birth"),
  nationality: string().required("Location is required"),
  experienceCategory: string().required("Experience Category is required"),
  experienceYears: Yup.string().required("Experience Years is required"),
});

export const validationUpdateActorSchema = object().shape({
  businessEmail: string()
    .trim()
    .email("Invalid email id")
    .required("Business email is required"),
  businessMobileNo: string()
    .trim()
    .notRequired()
    .test("myphone", "Invalid mobile no", (value) => matchIsValidTel(value))
    .required("Business mobile is required"),
  profileCategoryId: Yup.string().required("Profile category is required"),
});
